import React, { useState } from "react";
import axios from "axios";

const GPACalculator = () => {
  const [grades, setGrades] = useState([{ grade: "", credit: "" }]);
  const [gpa, setGpa] = useState(null);

  const calculateGPA = async () => {
    const response = await axios.post("http://localhost:5000/calculate/gpa", { grades });
    setGpa(response.data.gpa);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">GPA Calculator</h2>
      {grades.map((g, index) => (
        <div key={index} className="flex gap-2 mt-3">
          <input type="number" placeholder="Grade" className="border p-2 w-1/2" onChange={(e) => { let newGrades = [...grades]; newGrades[index].grade = e.target.value; setGrades(newGrades); }} />
          <input type="number" placeholder="Credit Hours" className="border p-2 w-1/2" onChange={(e) => { let newGrades = [...grades]; newGrades[index].credit = e.target.value; setGrades(newGrades); }} />
        </div>
      ))}
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateGPA}>Calculate GPA</button>
      {gpa && <div className="mt-3 text-center text-lg">GPA: <span className="font-bold text-green-600">{gpa}</span></div>}
    </div>
  );
};

export default GPACalculator;
